import React from 'react'
import styled from '@emotion/styled'

import { breakpoints } from '../../constants'

export default ({ color, noCheck, size, themeColor }) => (
  <StyledCheckDotDiv color={color} size={size} themeColor={themeColor}>
    {!noCheck && <StyledImg src={__PATH_PREFIX__ + '/checkmark.svg'} />}
  </StyledCheckDotDiv>
)

const StyledImg = styled.img`
  max-width: 80%;
`

const StyledCheckDotDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${p => (p.size ? p.size * 0.75 : 12)}px;
  height: ${p => (p.size ? p.size * 0.75 : 12)}px;
  margin: 0px 4px;
  @media (min-width: ${breakpoints.mid}px) {
    width: ${p => (p.size ? p.size : 16)}px;
    height: ${p => (p.size ? p.size : 16)}px;
    margin: 0px 8px;
  }
  cursor: pointer;
  border-radius: 50%;
  background-color: ${p => (p.themeColor || p.color)};
`
